import { render, staticRenderFns } from "./MessageInbox.vue?vue&type=template&id=243211c5&scoped=true&"
import script from "./MessageInbox.vue?vue&type=script&lang=js&"
export * from "./MessageInbox.vue?vue&type=script&lang=js&"
import style0 from "./MessageInbox.vue?vue&type=style&index=0&id=243211c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243211c5",
  null
  
)

export default component.exports